import { type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { InstagramShareModal } from "../InstagramShareModal";
import * as styles from "./styles.css";

type Props = {
  xShareUrl: string;
  facebookShareUrl: string;
  instagramShareUrl: string;
  instagramDisplayImageUrl: string;
  instagramShareImageUrl: string;
  isSp: boolean;
};

export const ShareButtonGroup: FC<Props> = ({
  xShareUrl,
  facebookShareUrl,
  instagramShareUrl,
  instagramDisplayImageUrl,
  instagramShareImageUrl,
  isSp,
}) => (
  <div className={styles.wrapper}>
    <InstagramShareModal
      shareUrl={instagramShareUrl}
      displayImageUrl={instagramDisplayImageUrl}
      shareImageUrl={instagramShareImageUrl}
      isSp={isSp}
    />
    <a href={xShareUrl} target="_blank" rel="noopener noreferrer" className={styles.shareButton}>
      <div className={styles.iconWrapper}>
        <LazyLoadImage
          src="/images/user_frontend/special/rejob_awards_2026/icn_sns_x.png"
          alt="Xでポストする"
          width={40}
          height={40}
        />
      </div>
    </a>
    <a
      href={facebookShareUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.shareButton}
    >
      <div className={styles.iconWrapper}>
        <LazyLoadImage
          src="/images/user_frontend/special/rejob_awards_2026/icn_sns_facebook.png"
          alt="Facebookでシェアする"
          width={40}
          height={40}
        />
      </div>
    </a>
  </div>
);
